import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fallbackValue',
  standalone: true,
})
export class FallbackValuePipe implements PipeTransform {
  transform(value: string | number | null | undefined, fallback: string = '-'): string | number {
    return value == null || value === '' ? fallback : value;
  }
}
